import trackerHelper from "@coworker/app/src/helpers/tracker";
import FixaPill from "../../../wrappers/FixaPill/FixaPill";
import PillRadioButtonCss from "./PillRadioButton.module.css";
import { FilterValue, RadioButtonFilter } from "../../types/filter";
import { TrackingProps } from "../../types/component";

interface PillRadioButtonProps {
  filter: RadioButtonFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  tracking: TrackingProps;
}

export const PillRadioButton = ({
  filter,
  filterValues,
  setFilterValues,
  tracking,
}: PillRadioButtonProps) => {
  const checked =
    filterValues.find((value) => value.filterId === filter.idToUpdate)
      ?.value === filter.valueToSet;

  const handleRadioButtonClick = () => {
    if (!checked) {
      trackerHelper.filter.trackFilterRowClicked(
        tracking.feature,
        tracking.mode,
        filter.id
      );
    }

    const updatedFilters = filterValues.filter(
      (value) => value.filterId !== filter.idToUpdate
    );

    setFilterValues(
      checked
        ? updatedFilters
        : [
            ...updatedFilters,
            {
              filterId: filter.idToUpdate ?? "",
              value: filter.valueToSet ?? "",
            },
          ]
    );
  };

  return (
    <FixaPill
      id={filter.id}
      size="small"
      label={
        <div className={PillRadioButtonCss["pill-wrapper"]}>
          {filter.title}
          <input
            className={PillRadioButtonCss["radio-button"]}
            type="radio"
            checked={checked}
            readOnly
          />
        </div>
      }
      onClick={handleRadioButtonClick}
    />
  );
};
